import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { LatestProcessDesign } from './latest-process-design';
export { LatestProcessDesign };
import { latestProcessDesignSchema } from '@schemas/business-objects/latest-process-design';
import { TenantFormGroup } from './tenant-form-group';

export class LatestProcessDesignFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    designUuid: SchemaFormControl;
    name: SchemaFormControl;
    displayName: SchemaFormControl;
    description: SchemaFormControl;
    version: SchemaFormControl;
    suspended: SchemaFormControl;
    createdAt: SchemaFormControl;
    updatedAt: SchemaFormControl;
    activeInstanceCount: SchemaFormControl;
    errorInstanceCount: SchemaFormControl;
    tenantId: SchemaFormControl;
    tenant: TenantFormGroup;
  };

  declare value: Partial<LatestProcessDesign>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(latestProcessDesignSchema, LatestProcessDesign, data, options);
  }

  get object(): LatestProcessDesign {
    return new LatestProcessDesign(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'tenant':
        return new TenantFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<LatestProcessDesign[]> {
    return LatestProcessDesign.find(filter);
  }

  static async findOne(filter?: any): Promise<LatestProcessDesign | null> {
    return LatestProcessDesign.findOne(filter);
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<LatestProcessDesign> {
    return LatestProcessDesign.findById(id, filter);
  }

  static async create(
    data: Partial<LatestProcessDesign>,
  ): Promise<LatestProcessDesign> {
    return LatestProcessDesign.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<LatestProcessDesign>,
  ): Promise<LatestProcessDesign> {
    return LatestProcessDesign.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return LatestProcessDesign.deleteById(id);
  }
}

export class LatestProcessDesignFormArray extends PersistedFormArray {
  declare controls: LatestProcessDesignFormGroup[];

  readonly entityName = 'LatestProcessDesign' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(latestProcessDesignSchema, LatestProcessDesign, options);
  }

  protected override createItemGroup() {
    return new LatestProcessDesignFormGroup();
  }

  get array(): LatestProcessDesign[] {
    return this.controls.map(
      (group: LatestProcessDesignFormGroup) => group.object,
    );
  }
}

export class LatestProcessDesignPersistedArray extends PersistedArray<LatestProcessDesign> {
  readonly entityName = 'LatestProcessDesign' as const;

  constructor(options?: PersistedArrayOptions) {
    super(LatestProcessDesign, options);
  }
}
